/* --- js/deferred/front-chat-init.js --- */
(function () {
  var loaded = false;

  function loadFrontChat() {
    if (loaded) return;
    loaded = true;
    cleanup();

    var script = document.createElement("script");
    script.src = "https://chat-assets.frontapp.com/v1/chat.bundle.js";
    script.onload = function () {
      window.FrontChat("init", {
        chatId: "b41bb2f7aa9f770936606bfbcf32c27f",
        useDefaultLauncher: true,
      });
    };
    document.body.appendChild(script);
  }

  var events = ["scroll", "click", "touchstart", "keydown"];

  function cleanup() {
    events.forEach(function (evt) {
      window.removeEventListener(evt, loadFrontChat);
    });
  }

  events.forEach(function (evt) {
    window.addEventListener(evt, loadFrontChat, { once: true, passive: true });
  });
})();


/* --- js/deferred/zapiet.js --- */
class ZapietDeliveryWarner extends HTMLElement {
  constructor() {
    super();
    window.ZapietEvent.listen("locationSelected", this.onLocation.bind(this));
  }

  onLocation(params) {
    const show =
      params.method == "delivery" &&
      params.location.company_name != "West Footscray";
    this.toggleAttribute("data-show", show);
  }
}

customElements.define("zapiet-delivery-warning", ZapietDeliveryWarner);


/* --- js/deferred/video-on-demand.js --- */
class VideoOnDemand extends HTMLElement {
  static _VIDEOPLAYING = "video-playing";
  #observer = /** @type {IntersectionObserver | null} */ (null);
  #isMobile = false;
  #posterMobile;
  #poster;
  #video;
  #videoSource;

  constructor() {
    super();
    this.#isMobile = !window.matchMedia("(min-width: 1024px)").matches;
    this.#posterMobile = /** @type {HTMLImageElement} */ (
      this.throw.element("img.lg\\:hidden")
    );
    this.#poster = /** @type {HTMLImageElement} */ (
      this.throw.element("img.lg\\:block")
    );
    this.#video = /** @type {HTMLVideoElement} */ (this.throw.element("video"));
    this.#videoSource = /** @type {HTMLSourceElement} */ (
      this.throw.element("source")
    );
  }

  connectedCallback() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.handlePosterLoad();
            this.#observer?.unobserve(this);
          }
        });
      },
      {
        rootMargin: "50px",
        threshold: 0.1,
      },
    );

    this.#observer.observe(this);
  }

  disconnectedCallback() {
    if (this.#observer) {
      this.#observer.disconnect();
    }
  }

  /**
   * Wait for the poster and page to load before loading the video.
   */
  handlePosterLoad() {
    const img = this.#isMobile ? this.#posterMobile : this.#poster;

    const imageReady = img.complete
      ? Promise.resolve()
      : new Promise((resolve) =>
          img.addEventListener("load", resolve, { once: true }),
        );

    const pageReady =
      document.readyState === "complete"
        ? Promise.resolve()
        : new Promise((resolve) =>
            window.addEventListener("load", resolve, { once: true }),
          );

    img.addEventListener(
      "error",
      () => console.warn("Poster failed to load:", img.src),
      { once: true },
    );

    Promise.all([imageReady, pageReady]).then(() => this.loadVideo());
  }

  /**
   * Loads the video source, plays the video, and toggles visibility classes
   */
  loadVideo() {
    const img = this.#isMobile ? this.#posterMobile : this.#poster;

    const src = this.#isMobile
      ? this.#videoSource.getAttribute("data-src-mobile")
      : this.#videoSource.getAttribute("data-src");
    if (!src) throw Error("Video source not found");

    const type = this.#isMobile
      ? this.#videoSource.getAttribute("data-video-type-mobile")
      : this.#videoSource.getAttribute("data-video-type");
    if (!type) throw Error("Video type not found");

    this.#videoSource.src = src;
    this.#videoSource.type = type;
    this.#video.preload = "auto";
    this.#video.load();

    this.#video.addEventListener(
      "canplaythrough",
      () => {
        img.classList.add("opacity-0");
        this.#video.classList.remove("hidden");
        this.#video.play();
        this.#video.dispatchEvent(
          new Event(VideoOnDemand._VIDEOPLAYING, { bubbles: true }),
        );
      },
      { once: true },
    );
  }
}

customElements.define("video-on-demand", VideoOnDemand);


/* --- js/deferred/web-components.js --- */
// ---------------------------------------------------------------------------
// Text Area
// ---------------------------------------------------------------------------

class ValidatedTextarea extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const textarea = this.querySelector("textarea");
    if (!textarea) throw Error("No textarea found");
    const count = this.querySelector('[data-name="char-count"]');
    if (!count) throw Error("No char count element found");

    textarea.addEventListener("input", () => {
      this.sanitizeTextareaInput(textarea);
      this.updateCharCount(textarea, count);
    });
  }

  /**
   * Sanitizes the input value of a textarea to only allow a-z, 0-9, _, -, :, space (case insensitive).
   * @param {HTMLTextAreaElement} textarea - The textarea element to sanitize.
   */
  sanitizeTextareaInput(textarea) {
    let value = textarea.value;
    // Remove any character that is NOT allowed
    value = value.replace(/[^a-z0-9_\-: !@$#%^&();\[\]\,?\.\'\"]/gi, "");
    // Optional: normalize multiple spaces
    value = value.replace(/\s+/g, " ");
    textarea.value = value;
  }

  /**
   * Updates the character count of a textarea.
   * @param {HTMLTextAreaElement} textarea - The textarea element to update.
   * @param {Element} charCountElement - The element to display the character count.
   */
  updateCharCount(textarea, charCountElement) {
    const length = textarea.value.length;
    const max = textarea.maxLength;
    charCountElement.textContent = `${length}/${max}`;
  }
}
customElements.define("validated-textarea", ValidatedTextarea);

class ItemQuantity extends HTMLElement {
  connectedCallback() {
    const input = /** @type {HTMLInputElement} */ (
      this.querySelector('input[name="quantity"]')
    );
    const increment = /** @type {HTMLButtonElement} */ (
      this.querySelector("[data-increment]")
    );
    const decrement = /** @type {HTMLButtonElement} */ (
      this.querySelector("[data-decrement]")
    );
    const adjust = (/** @type {number} */ delta) => {
      const newValue = parseInt(input.value) + delta;
      input.value = String(newValue);
      decrement.disabled = newValue <= 1;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    };

    increment.addEventListener("click", () => adjust(1));
    decrement.addEventListener("click", () => adjust(-1));
  }
}
customElements.define("item-quantity", ItemQuantity);

const _SCROLL_SNAP_TARGET = "data-snap-target";
const _SCROLL_INDICATORS = "data-indicators";
const _SCROLL_HIDE = "data-hideable";
const _SCROLL_HIDE_ATTR = "data-hidden";
const _SCROLL_LEFT = "data-left";
const _SCROLL_RIGHT = "data-right";
const _SCROLL_SELECTED = "data-selected";
const _SCROLL_REFRESH = "data-refresh";

class ScrollIndicator extends HTMLElement {
  #items = /** @type {HTMLElement[]} */ ([]);
  #indicators = /** @type {HTMLElement[]} */ ([]);
  #activeIndex = 0;
  #intersectionObserver = /** @type {IntersectionObserver | null} */ (null);
  #intersectionRatios = new Map();
  #resizeObserver = /** @type {ResizeObserver | null} */ (null);
  #boundApplyScroll = /** @type {(() => void) | null} */ (null);

  static get observedAttributes() {
    return [_SCROLL_REFRESH];
  }

  /** Reinitializes the scroll indicator when the refresh attribute changes.
   *
   * @param {string} name - The name of the attribute that changed.
   * @param {string | null} oldValue - The old value of the attribute.
   * @param {string | null} newValue - The new value of the attribute.
   */
  attributeChangedCallback(name, oldValue, newValue) {
    if (name === _SCROLL_REFRESH && oldValue !== newValue) {
      setTimeout(() => {
        this.disconnectedCallback();
        this.connectedCallback();
      }, 100);
    }
  }

  connectedCallback() {
    this.#newIndicators();
    this.#swipeListeners();
    this.#initHideScroll();
    this.#buttonListeners();
  }

  disconnectedCallback() {
    this.#resizeObserver?.disconnect();
    this.#intersectionObserver?.disconnect();
    if (this.#boundApplyScroll) {
      window.removeEventListener("resize", this.#boundApplyScroll);
      window.removeEventListener("load", this.#boundApplyScroll);
    }
    // Reset items/indicators so connectedCallback starts clean
    this.#items = [];
    this.#indicators = [];
    this.#activeIndex = 0;
    this.#intersectionRatios = new Map();
  }

  #newIndicators() {
    const snapTarget = this.getAttribute(_SCROLL_SNAP_TARGET);
    if (!snapTarget) {
      throw Error(
        `[scroll-indicator]: ${_SCROLL_SNAP_TARGET} attribute is required`,
      );
    }
    this.#items = Array.from(this.querySelectorAll(snapTarget));
    if (this.#items.length === 0) {
      throw Error("[scroll-indicator]: no snap target items found");
    }

    const indicatorSelector = this.getAttribute(_SCROLL_INDICATORS);
    if (!indicatorSelector) {
      throw Error(
        `[scroll-indicator]: ${_SCROLL_INDICATORS} attribute is required`,
      );
    }

    const baseIndicator = this.throw.element(indicatorSelector);
    const parent = baseIndicator.parentElement;
    if (!parent) {
      throw Error("[scroll-indicator]: scroll indicators need a parent");
    }

    // Remove all existing indicators and rebuild from scratch
    parent.querySelectorAll(indicatorSelector).forEach((el) => el.remove());

    const fragment = document.createDocumentFragment();
    for (let i = 0; i < this.#items.length; i++) {
      fragment.appendChild(baseIndicator.cloneNode(true));
    }
    parent.appendChild(fragment);

    this.#indicators = Array.from(parent.querySelectorAll(indicatorSelector));
    this.#setActive(0);
  }

  #swipeListeners() {
    if (window.matchMedia("(min-width: 1023px)").matches) return;

    const parent = this.#items[0]?.closest(".overflow-x-auto");
    if (!parent) {
      throw Error("[scroll-indicator]: snap targets need a parent");
    }

    this.#intersectionObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          this.#intersectionRatios.set(entry.target, entry.intersectionRatio);
        }

        // Find the best across ALL items, not just changed ones
        let bestIndex = -1;
        let bestRatio = 0;
        this.#items.forEach((item, index) => {
          const ratio = this.#intersectionRatios.get(item) ?? 0;
          if (ratio > bestRatio) {
            bestRatio = ratio;
            bestIndex = index;
          }
        });

        if (bestIndex !== -1) this.#setActive(bestIndex);
      },
      { root: parent, threshold: [0.4, 0.5, 0.6] },
    );

    this.#items.forEach((item) => {
      this.#intersectionRatios.set(item, 0);
      this.#intersectionObserver?.observe(item);
    });
  }

  /**
   * Scrolls to the next item in the given direction.
   * @param {number} index - The current active index.
   * @param {number} direction - The direction to scroll (1 for forward, -1 for backward).
   */
  #scrollBy(index, direction) {
    const itemCount = this.#items.length;
    if (itemCount === 0) {
      throw Error("[scroll-indicator]: #items needs at least one item");
    }
    const nextIndex =
      (((index + direction) % itemCount) + itemCount) % itemCount;
    this.#items[nextIndex].scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
    this.#setActive(nextIndex);
  }

  #buttonListeners() {
    const leftAttribute = this.getAttribute(_SCROLL_LEFT);
    const rightAttribute = this.getAttribute(_SCROLL_RIGHT);
    if (!leftAttribute || !rightAttribute) return;

    this.throw
      .element(leftAttribute)
      .addEventListener("click", () => this.#scrollBy(this.#activeIndex, -1));
    this.throw
      .element(rightAttribute)
      .addEventListener("click", () => this.#scrollBy(this.#activeIndex, 1));
  }

  #initHideScroll() {
    const scrollArea = /** @type {HTMLElement} */ (
      this.#items[0].closest(".overflow-x-auto")
    );
    if (!scrollArea) {
      throw Error(
        `[scroll-indicator]: snap targets need a parent with 'overflow-x-auto'`,
      );
    }
    const hideAttribute = this.getAttribute(_SCROLL_HIDE);
    if (!hideAttribute) {
      return;
    }
    const hideable = this.throw.any(hideAttribute);

    this.#boundApplyScroll = () => {
      const noScroll = scrollArea.scrollWidth <= scrollArea.clientWidth;
      hideable.forEach((element) =>
        element.setAttribute(_SCROLL_HIDE_ATTR, String(noScroll)),
      );
    };

    this.#resizeObserver = new ResizeObserver(this.#boundApplyScroll);
    this.#resizeObserver.observe(scrollArea);
  }

  /** Sets the active tab button based on the given index
   *
   * @param {number} index - The index of the active tab
   */
  #setActive(index) {
    this.#indicators[this.#activeIndex].removeAttribute(_SCROLL_SELECTED);
    this.#indicators[index].setAttribute(_SCROLL_SELECTED, "");
    this.#activeIndex = index;
  }
}

customElements.define("scroll-indicator", ScrollIndicator);

// ---------------------------------------------------------------------------
// Autoplay Video
// ---------------------------------------------------------------------------

class AutoplayVideo extends HTMLElement {
  #observer = /** @type {IntersectionObserver | null} */ (null);
  #video = /** @type {HTMLVideoElement | null} */ (null);
  #source = /** @type {HTMLSourceElement | null} */ (null);

  constructor() {
    super();
    this.#observer = null;
    this.#video = /** @type {HTMLVideoElement} */ (this.throw.element("video"));
    this.#source = /** @type {HTMLSourceElement} */ (
      this.throw.element("source")
    );
  }

  connectedCallback() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.#loadVideo();
            this.disconnectedCallback();
          }
        });
      },
      {
        root: null,
        threshold: 0.6,
      },
    );

    /** @ts-ignore */
    this.#observer.observe(this.#video);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #loadVideo() {
    const src = this.#source?.getAttribute("data-src");
    if (!src) throw Error("[autoplay-video]: Video source not found");

    const type = this.#source?.getAttribute("data-video-type");
    if (!type) throw Error("[autoplay-video]: Video type not found");

    this.#source?.setAttribute("src", src);
    this.#source?.setAttribute("type", type);
    this.#video?.setAttribute("preload", "auto");
    this.#video?.load();

    this.#video?.addEventListener(
      "canplaythrough",
      () => {
        this.#video?.play();
      },
      { once: true },
    );
  }
}

customElements.define("autoplay-video", AutoplayVideo);

// ---------------------------------------------------------------------------
// Cart Components
// ---------------------------------------------------------------------------

class CheckoutButton extends HTMLElement {
  /** @type {HTMLButtonElement} */
  #button;
  /** @type {HTMLFormElement} */
  #leavePackageForm;
  #isZapietOk = true;
  #hxInFlight = false;

  constructor() {
    super();
    this.#button = /** @type {HTMLButtonElement} */ (
      this.querySelector("button")
    );
    if (!this.#button) throw new Error("checkout-button: <button> not found");

    this.#leavePackageForm = /** @type {HTMLFormElement} */ (
      document.querySelector("#leave-package-form")
    );
    if (!this.#leavePackageForm) {
      throw new Error("checkout-button: #leave-package-form not found");
    }
  }

  connectedCallback() {
    this.#button.addEventListener("click", this.#handleClick);

    /** @ts-ignore */
    const zapiet = window.ZapietEvent;
    zapiet.listen("checkoutEnabled", () => {
      this.#isZapietOk = true;
      this.#evaluate();
    });
    zapiet.listen("checkoutDisabled", () => {
      this.#isZapietOk = false;
      this.#evaluate();
    });
    zapiet.listen("delivery.datepicker.rendered", () => {
      this.#leavePackageForm.dataset.isDelivery = "true";
      this.#evaluate();
    });
    zapiet.listen("shipping.datepicker.rendered", () => {
      this.#leavePackageForm.dataset.isDelivery = "true";
      this.#evaluate();
    });
    zapiet.listen("pickup.datepicker.rendered", () => {
      this.#leavePackageForm.dataset.isDelivery = "false";
      this.#evaluate();
    });

    this.#leavePackageForm.addEventListener("hx:after-swap", () => {
      this.#evaluate();
    });

    document.body.addEventListener("hx:before-swap", () => {
      this.#hxInFlight = true;
      this.#evaluate();
    });

    document.body.addEventListener("hx:after-swap", () => {
      this.#hxInFlight = false;
      this.#evaluate();
    });

    this.#evaluate();
  }

  get #isDelivery() {
    const isDelivery = this.#leavePackageForm.dataset.isDelivery;
    if (!isDelivery) throw Error("checkout-button: missing isDelivery dataset");
    return isDelivery == "true";
  }

  get #leavePackageAnswered() {
    return !!this.#leavePackageForm?.querySelector("input:checked");
  }

  get #canCheckout() {
    if (!this.#isZapietOk) return false;
    if (this.#isDelivery && !this.#leavePackageAnswered) return false;
    if (this.#hxInFlight) return false;
    return true;
  }

  #evaluate() {
    if (!this.#button) {
      throw new Error("checkout-button: <button> not found");
    }
    this.#button.disabled = !this.#canCheckout;
  }

  #handleClick = () => {
    if (!this.#button) {
      throw new Error("checkout-button: <button> not found");
    }
    const href = this.throw
      .element("[data-name='hijacker']")
      .getAttribute("href");
    if (!href) throw new Error("checkout-button: missing href attribute");
    window.location.href = href;
  };
}

customElements.define("checkout-button", CheckoutButton);


/* --- js/deferred/sticky-header.js --- */
class StickyHeader extends HTMLElement {
  #isSticky = signal(false);

  constructor() {
    super();
    const sentinel = document.getElementById("header-sentinel");
    if (sentinel) {
      this.init(sentinel);
    }
  }

  /** Initializes the sticky header with the given sentinel element.
   *  @param {HTMLElement} sentinel - The sentinel element to observe. */
  init(sentinel) {
    new IntersectionObserver(([entry]) => {
      this.#isSticky.value = !entry.isIntersecting;
    }).observe(sentinel);

    effect(() => {
      if (this.#isSticky.value) {
        this.setAttribute("data-sticky", "");
      } else {
        this.removeAttribute("data-sticky");
      }
    });
  }
}

customElements.define("sticky-header", StickyHeader);


/* --- js/deferred/elastic-scroll.js --- */
class ElasticScroll extends HTMLElement {
  // ---------------------------------------------------------------------------
  // Signals and State Variables
  // ---------------------------------------------------------------------------
  #position = signal(0);
  #maxPosition = signal(0);
  #isDragging = signal(false);
  #itemWidth = signal(0);
  #containerWidth = signal(0);
  #lastActiveIndex = 0;
  #velocity = signal(0);

  // Computed signals (initialized in constructor)
  #isAtStart;
  #isAtEnd;

  // Drag tracking variables
  #startX = 0;
  #startY = 0;
  #startPosition = 0;
  #lastX = 0;
  #lastTime = 0;
  #lastTickTime = 0;
  #currentDt = 16.67;
  #isMoving = false;

  // Animation & Configuration Constants
  #FRICTION = 0.93;
  #SNAP_BACK_SPEED = 0.15;
  #DRAG_SENSITIVITY = 1.33;
  #animationFrameId = 0;

  // Temporary State for Batch Callbacks (to avoid closures)
  #currentEventPageX = 0;
  #currentEventPageY = 0;
  #currentEventTime = 0;
  #currentTargetPos = 0;
  #currentVelocityPeek = 0;
  #currentPosPeek = 0;
  #currentMaxPosPeek = 0;
  #isOverscrolled = false;
  #shouldRequestFrame = false;

  /** @type {NodeJS.Timeout | null}  */
  resizeTimer = null;
  #bullets = /** @type {HTMLButtonElement[]} */ ([]);

  constructor() {
    super();

    // DOM Elements
    this.prevBtn = /** @type {HTMLButtonElement} */ (
      this.throw.element("button[data-previous]")
    );
    this.nextBtn = /** @type {HTMLButtonElement} */ (
      this.throw.element("button[data-next]")
    );
    this.pagination = this.throw.element("[data-pagination]");
    this.track = this.throw.element("[data-track]");
    this.items = [...this.throw.any("[data-item]")];

    if (this.items.length === 0) {
      throw Error("[elastic-scroll]: No items found");
    }

    // Initialize Computed Signals
    this.#isAtStart = computed(this.#isAtStartCalc);
    this.#isAtEnd = computed(this.#isAtEndCalc);
  }

  connectedCallback() {
    this.measureAndCacheDOM();
    this.prevBtn.addEventListener("click", () => this.scrollByBullets(-1));
    this.nextBtn.addEventListener("click", () => this.scrollByBullets(1));
    window.addEventListener("resize", this.handleResize);
    this.updateNumberOfBullets();
    this.addDragListeners();
    this.setupEffects();
    this.updateActiveBullet();
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this.handleResize);
    this.removeDragListeners();
    this.#cancelMomentum();
    if (this.resizeTimer !== null) clearTimeout(this.resizeTimer);
  }

  // ---------------------------------------------------------------------------
  // Pre-bound Callbacks via Private Class Fields
  // ---------------------------------------------------------------------------

  #isAtStartCalc = () => {
    return this.#position.value >= 0;
  };

  #isAtEndCalc = () => {
    return this.#position.value <= this.#maxPosition.value;
  };

  #syncTransform = () => {
    this.track.style.transform = `translate3d(${this.#position.value}px, 0, 0)`;
  };

  #syncButtons = () => {
    const isStart = this.#isAtStart.value;
    const isEnd = this.#isAtEnd.value;

    if (this.prevBtn.disabled !== isStart) {
      this.prevBtn.disabled = isStart;
    }
    if (this.nextBtn.disabled !== isEnd) {
      this.nextBtn.disabled = isEnd;
    }
  };

  #syncBullets = () => {
    this.#position.value;
    this.#maxPosition.value;
    this.#itemWidth.value;
    this.updateActiveBullet();
  };

  #momentumEffect = () => {
    if (this.#isDragging.value) return;
    this.#animationFrameId = requestAnimationFrame(this.#tick);
    return this.#cancelMomentum;
  };

  #cancelMomentum = () => {
    cancelAnimationFrame(this.#animationFrameId);
  };

  #tick = () => {
    const now = performance.now();
    const dt = this.#lastTickTime ? now - this.#lastTickTime : 16.67;
    this.#lastTickTime = now;
    // Clamp to avoid huge jumps after a dropped/backgrounded tab
    this.#currentDt = Math.min(dt, 32);

    this.#currentVelocityPeek = this.#velocity.peek();
    this.#currentPosPeek = this.#position.peek();
    this.#currentMaxPosPeek = this.#maxPosition.peek();
    this.#isOverscrolled =
      this.#currentPosPeek > 0 ||
      this.#currentPosPeek < this.#currentMaxPosPeek;

    batch(this.#tickBatch);

    if (this.#shouldRequestFrame) {
      this.#animationFrameId = requestAnimationFrame(this.#tick);
    } else {
      this.#lastTickTime = 0; // reset so next momentum start doesn't use a stale dt
    }
  };

  #tickBatch = () => {
    let v = this.#currentVelocityPeek;
    const pos = this.#currentPosPeek;
    const maxPos = this.#currentMaxPosPeek;
    const dt = this.#currentDt;
    this.#shouldRequestFrame = true;

    if (this.#isOverscrolled) {
      this.#velocity.value = 0;
      if (pos > 0) {
        this.#position.value = pos * (1 - this.#SNAP_BACK_SPEED);
        if (this.#position.value < 0.1) this.#position.value = 0;
      } else {
        this.#position.value =
          maxPos + (pos - maxPos) * (1 - this.#SNAP_BACK_SPEED);
        if (this.#position.value > maxPos - 0.1) {
          this.#position.value = maxPos;
        }
      }
    } else if (Math.abs(v) > 0.01) {
      let nextPos = pos + v * dt;
      if (nextPos > 0) {
        v *= 0.1;
        nextPos = pos + v * dt;
      } else if (nextPos < maxPos) {
        v *= 0.1;
        nextPos = pos + v * dt;
      }
      // friction should also be dt-aware so it feels the same at any refresh rate
      const frictionThisFrame = Math.pow(this.#FRICTION, dt / 16.67);
      this.#velocity.value = v * frictionThisFrame;
      this.#position.value = nextPos;
    } else {
      this.#velocity.value = 0;
      this.#shouldRequestFrame = false;
    }
  };

  #isBulletSelected = (element) => {
    return element.hasAttribute("data-selected");
  };

  #clearTransition = () => {
    this.track.style.transition = "";
  };

  #onBulletClick = (e) => {
    const target = Number(e.currentTarget.dataset.target);
    this.animateTo(target);
  };

  #startDragBatch = () => {
    this.#isDragging.value = true;
    this.#startX = this.#currentEventPageX;
    this.#startY = this.#currentEventPageY;
    this.#startPosition = this.#position.peek();
  };

  #startDrag = (e) => {
    this.#currentEventPageX = this.#getPageX(e);
    this.#currentEventPageY = this.#getPageY(e);
    batch(this.#startDragBatch);

    this.#lastX = this.#currentEventPageX;
    this.#lastTime = performance.now();
    this.track.style.transition = "";
    this.#isMoving = false;
  };

  #moveDragBatch = () => {
    this.#velocity.value = 0;
    const deltaTime = this.#currentEventTime - this.#lastTime;

    if (deltaTime > 1) {
      const rawVelocity =
        ((this.#currentEventPageX - this.#lastX) * this.#DRAG_SENSITIVITY) /
        deltaTime;
      this.#velocity.value = this.#velocity.peek() * 0.4 + rawVelocity * 0.6;
    }

    const maxPos = this.#maxPosition.peek();

    if (this.#currentTargetPos > 0) {
      this.#position.value = this.#currentTargetPos * 0.3;
    } else if (this.#currentTargetPos < maxPos) {
      this.#position.value = maxPos + (this.#currentTargetPos - maxPos) * 0.3;
    } else {
      this.#position.value = this.#currentTargetPos;
    }

    this.#lastX = this.#currentEventPageX;
    this.#lastTime = this.#currentEventTime;
  };

  #moveDrag = (e) => {
    if (!this.#isDragging.peek()) return;

    this.#currentEventPageX = this.#getPageX(e);
    this.#currentEventTime = performance.now();

    const deltaX = this.#currentEventPageX - this.#startX;
    const walk = deltaX * this.#DRAG_SENSITIVITY;

    this.#currentTargetPos = this.#startPosition + walk;
    this.#isMoving = true;

    batch(this.#moveDragBatch);
  };

  #endDragFrame = () => {
    this.#isMoving = false;
    this.#isDragging.value = false;
  };

  #endDrag = () => {
    if (performance.now() - this.#lastTime > 50) {
      this.#velocity.value = 0;
    }
    requestAnimationFrame(this.#endDragFrame);
  };

  #onMouseMove = (e) => {
    if (this.#isDragging.peek()) e.preventDefault();
    this.#moveDrag(e);
  };

  #onTouchMove = (e) => {
    const dx = Math.abs(this.#getPageX(e) - this.#startX);
    const dy = Math.abs(this.#getPageY(e) - this.#startY);
    if (dx > dy && e.cancelable) e.preventDefault();
    this.#moveDrag(e);
  };

  #onClick = (e) => {
    const link = e.target.closest("a");
    if (this.#isMoving) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return false;
    }
  };

  #measureAndCacheDOMBatch = () => {
    this.#containerWidth.value = Math.min(
      this.track.clientWidth,
      this.clientWidth,
    );
    const trackStyle = getComputedStyle(this.track);
    const gap = parseFloat(trackStyle.gap) || 0;

    this.#itemWidth.value = this.items[0].offsetWidth + gap;
    const paddingLeft = parseFloat(trackStyle.paddingLeft) || 0;

    this.#maxPosition.value = -(
      this.track.scrollWidth +
      paddingLeft -
      this.#containerWidth.peek()
    );
  };

  #handleResizeTimeout = () => {
    this.measureAndCacheDOM();
    this.#position.value = Math.max(
      this.#maxPosition.peek(),
      Math.min(0, this.#position.peek()),
    );
    this.updateNumberOfBullets();
  };

  // We make handleResize a public arrow function to avoid needing to bind it in the constructor
  handleResize = () => {
    if (this.resizeTimer !== null) clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(this.#handleResizeTimeout, 150);
  };

  // ---------------------------------------------------------------------------
  // Setup & Layout Methods
  // ---------------------------------------------------------------------------

  setupEffects() {
    effect(this.#syncTransform);
    effect(this.#syncButtons);
    effect(this.#syncBullets);
    effect(this.#momentumEffect);
  }

  scrollByBullets(direction) {
    const i = this.#bullets.findIndex(this.#isBulletSelected);
    if (this.#bullets[i + direction]) {
      this.#bullets[i + direction].click();
    }
  }

  snapToNearest() {
    const itemW = this.#itemWidth.peek();
    const index = Math.round(-this.#position.peek() / itemW);
    const clamped = Math.max(0, Math.min(this.items.length - 1, index));
    this.animateTo(Math.max(this.#maxPosition.peek(), -(clamped * itemW)));
  }

  animateTo(target) {
    this.track.style.transition =
      "transform 0.4s cubic-bezier(0.25, 1, 0.5, 1)";
    this.#position.value = target;
    setTimeout(this.#clearTransition, 400);
  }

  updateActiveBullet() {
    if (this.#bullets.length < 2) return;

    let activePageIndex = 0;
    const totalBullets = this.#bullets.length;
    const currentPos = this.#position.peek();
    const maxPos = this.#maxPosition.peek();
    const itemW = this.#itemWidth.peek();

    if (currentPos <= maxPos) {
      activePageIndex = totalBullets - 1;
    } else if (currentPos >= 0) {
      activePageIndex = 0;
    } else if (totalBullets === 2) {
      activePageIndex = currentPos === maxPos ? 1 : 0;
    } else {
      const itemsPerPage = Math.max(
        1,
        Math.floor(this.#containerWidth.peek() / itemW),
      );
      activePageIndex = Math.max(
        0,
        Math.min(
          totalBullets - 1,
          Math.round(-currentPos / (itemW * itemsPerPage)),
        ),
      );
    }

    if (activePageIndex === this.#lastActiveIndex) return;
    this.#lastActiveIndex = activePageIndex;

    for (let i = 0; i < this.#bullets.length; i++) {
      this.#bullets[i].toggleAttribute("data-selected", i === activePageIndex);
    }
  }

  updateNumberOfBullets() {
    const itemW = this.#itemWidth.peek();
    const itemsPerPage = Math.max(
      1,
      Math.floor(this.#containerWidth.peek() / itemW),
    );
    const totalPages = Math.ceil(this.items.length / itemsPerPage);
    const currentButtons = this.pagination.throw.any("button");

    for (let i = 1; i < currentButtons.length; i++) {
      currentButtons[i].remove();
    }

    const template = currentButtons[0];
    this.#bullets = [];

    for (let i = 0; i < totalPages; i++) {
      const bullet = /** @type {HTMLButtonElement} */ (
        template.cloneNode(true)
      );
      const targetPos = Math.max(
        this.#maxPosition.peek(),
        -(i * itemsPerPage * this.#itemWidth.peek()),
      );
      bullet.dataset.target = targetPos.toString();
      bullet.addEventListener("click", this.#onBulletClick);

      this.pagination.appendChild(bullet);
      this.#bullets.push(bullet);
    }

    template.remove();
    if (totalPages < 2) {
      this.pagination.setAttribute("data-hidden", "");
    } else {
      this.pagination.removeAttribute("data-hidden");
    }

    this.#lastActiveIndex = -1;
    this.updateActiveBullet();
  }

  #getPageX(e) {
    return e.touches?.[0]?.pageX ?? e.pageX;
  }

  #getPageY(e) {
    return e.touches?.[0]?.pageY ?? e.pageY;
  }

  addDragListeners() {
    this.addEventListener("mousedown", this.#startDrag);
    this.addEventListener("mousemove", this.#onMouseMove);
    window.addEventListener("mouseup", this.#endDrag);
    this.addEventListener("mouseleave", this.#endDrag);

    this.addEventListener("touchstart", this.#startDrag, { passive: false });
    this.addEventListener("touchmove", this.#onTouchMove, { passive: false });
    window.addEventListener("touchend", this.#endDrag);
    window.addEventListener("touchcancel", this.#endDrag);
    this.addEventListener("click", this.#onClick, true);
  }

  measureAndCacheDOM() {
    batch(this.#measureAndCacheDOMBatch);
  }

  removeDragListeners() {
    window.removeEventListener("mouseup", this.#endDrag);
    window.removeEventListener("touchend", this.#endDrag);
    window.removeEventListener("touchcancel", this.#endDrag);
  }
}

customElements.define("elastic-scroll", ElasticScroll);
